import { Periode, PeriodeAPI } from "./periode";

export class DetailTelesuivi {
  periodeList: Periode[];

  constructor(
    periodeList: Periode[],
  ) {
    this.periodeList = periodeList;
  }

  static factory(detailTelesuiviAPI: DetailTelesuiviAPI): DetailTelesuivi {
    return new DetailTelesuivi(
      detailTelesuiviAPI.Periodes.Periode instanceof Array
        ? detailTelesuiviAPI.Periodes.Periode.map(
          (periode: PeriodeAPI) => Periode.factory(periode)
        )
        : [Periode.factory(detailTelesuiviAPI.Periodes.Periode)],
    );
  }
}

export type DetailTelesuiviAPI = {
  Periodes: {
    Periode: PeriodeAPI[] | PeriodeAPI;
  };
};